<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>供应系统</el-breadcrumb-item>
        <el-breadcrumb-item>运营管理</el-breadcrumb-item>
        <el-breadcrumb-item>限购模版设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="hx-form-container box-shadow">
      <el-form :model="listParams" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="限购规则：" prop="title">
              <el-input style="width: 100%" size="small" v-model="listParams.title" placeholder="请输入限购规则"> </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item>
              <el-button size="small" type="primary" @click="loadTableData"> 查询 </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <el-button class="align-left" type="primary" size="small" @click="toCreate"> 新增 </el-button>
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="tableData" max-height="800" border>
        <el-table-column align="center" width="60" label="序号">
          <template slot-scope="scope">
            <span v-text="(pager.pageIndex > 1 ? (pager.pageIndex - 1) * pager.pageSize : 0) + scope.$index + 1"> </span>
          </template>
        </el-table-column>

        <el-table-column prop="title" align="center" label="限购规则"> </el-table-column>

        <el-table-column prop="priority" align="center" label="使用状态">
          <template slot-scope="scope">
            <span v-if="scope.row.priority > 0"> 使用中 </span>
            <span v-else> 未使用 </span>
          </template>
        </el-table-column>

        <el-table-column prop="associatedGoodCount" align="center" label="关联商品数"> </el-table-column>

        <el-table-column prop="description" align="center" label="内容描述">
          <template slot-scope="scope">
            <div v-if="scope.row.description">
              <div v-if="scope.row.description.length > 10">
                <el-popover ref="popover1" placement="top-start" width="200" trigger="hover" :content="scope.row.description"> </el-popover>
                <el-button style="color: #606266" type="text" v-popover:popover1>
                  {{ scope.row.description | formatLimitLength }}
                </el-button>
              </div>
              <div v-else>
                {{ scope.row.description }}
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="detailItem(scope.row)">详情</el-button>
            <el-button type="text" @click="editItem(scope.row)">编辑</el-button>
            <confirm-button type="text" style="margin: 0 10px" title="确认要删除该条数据？" @confirmed="deleteItem(scope.row.id)">
              <span>删除</span>
            </confirm-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>
    <el-dialog class="hx-to-create-template" :title="dialogTitle" :visible.sync="dialogVisible" width="40%" @close="resetDialogForm" :close-on-click-modal="false">
      <div>
        <el-form ref="dialogForm" :model="itemParams" :rules="checkItemParams" label-width="120px">
          <el-form-item label="规则名称 ：" prop="title">
            <el-input v-model="itemParams.title" size="small" placeholder="请输入规则名称"> </el-input>
          </el-form-item>

          <el-form-item label="限购类型 ：" prop="type">
            <el-select style="width: 100%" v-model="itemParams.type" size="small" placeholder="请选择限购类型">
              <el-option :value="1" label="数量限购"></el-option>
              <el-option :value="2" label="规则限购"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="限购的值：" prop="value">
            <el-input-number v-if="itemParams.type === 1" size="small" v-model="itemParams.value" :min="1" :max="99" label="描述文字"> </el-input-number>
            <el-input-number v-else size="small" v-model="itemParams.value" :min="1" :max="999" label="描述文字"> </el-input-number>
          </el-form-item>

          <el-form-item label="优先级：" prop="priority">
            <el-input-number size="small" v-model="itemParams.priority" :min="1" :max="100" label="描述文字"> </el-input-number>
          </el-form-item>

          <el-form-item label="内容描述：" prop="description">
            <el-input size="small" type="textarea" :rows="4" placeholder="请输入内容描述" v-model="itemParams.description"> </el-input>
          </el-form-item>

          <el-form-item>
            <el-button :disabled="isDisabled" size="small" type="primary" @click="saveRestrictionRule('dialogForm')"> 保 存 </el-button>

            <el-button size="small" @click="dialogVisible = false"> 取 消 </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

    <el-dialog class="hx-to-create-template" title="限购规则详情" :visible.sync="detailVisible" width="40%" :close-on-click-modal="false">
      <el-form :model="detailParams" label-width="120px">
        <el-form-item label="规则名称 ：" prop="title">
          <span>{{ detailParams.title }}</span>
        </el-form-item>

        <el-form-item label="限购类型 ：" prop="type">
          <span v-if="detailParams.type === 1">数量限购</span>
          <span v-if="detailParams.type === 2">规则限购</span>
        </el-form-item>

        <el-form-item label="限购的值：" prop="value">
          <span>{{ detailParams.value }}</span>
        </el-form-item>

        <el-form-item label="优先级：" prop="priority">
          <span>{{ detailParams.priority }}</span>
        </el-form-item>

        <el-form-item label="内容描述：" prop="description">
          <span>{{ detailParams.description }}</span>
        </el-form-item>

        <el-form-item>
          <el-button size="small" @click="detailVisible = false"> 返 回 </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listParams: {
        title: "",
      },
      ruleList: [],
      tableLoading: false,
      tableData: [],
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      dialogTitle: "新增限制规则",
      dialogVisible: false,
      method: "",
      itemParams: {
        supplyId: "",
        title: "",
        type: 1,
        value: 0,
        priority: 10,
        description: "",
      },
      checkItemParams: {
        title: [{ required: true, message: "请输入规则名称", trigger: "blur" }],
        type: [{ required: true, message: "请选择限购类型", trigger: "change" }],
        value: [{ required: true, message: "请输入限购的值", trigger: "blur" }],
        priority: [{ required: true, message: "请输入优先级", trigger: "change" }],
        description: [{ required: true, message: "请输入内容描述", trigger: "blur" }],
      },
      isDisabled: false,
      detailVisible: false,
      detailParams: {},
    };
  },
  mounted() {
    this.loadTableData();
  },
  methods: {
    /**
     * 加载列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/good/supplyrule/findByPage",
        method: "GET",
        params: {
          title: this.listParams.title,
          pageIndex: this.pager.pageIndex,
          pageSize: this.pager.pageSize,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            if (res.body.data) {
              this.tableData = res.body.data.dataList;
              this.pager.total = res.body.data.total;
            } else {
              this.tableData = [];
            }
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    /**
     * 新增分类管理
     */
    toCreate() {
      this.dialogVisible = true;
      this.dialogTitle = "新增限购模板";
      this.method = "POST";
      if (this.itemParams.id) {
        delete this.itemParams.id;
      }
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * 保存新增或修改
     */
    saveRestrictionRule(name) {
      this.isDisabled = true;
      this.$refs[name].validate(valid => {
        if (valid) {
          const itemParams = Object.assign({}, this.itemParams);
          if (itemParams.type === 2) {
            itemParams.value = itemParams.value.toFixed(2);
          }
          this.$http({
            url: global.apiUrl + "/good/supplyrule",
            method: this.method,
            body: itemParams,
          })
            .then(res => {
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.dialogVisible = false;
                this.isDisabled = false;
                this.loadTableData();
              } else {
                this.isDisabled = false;
              }
            })
            .catch(err => {
              this.isDisabled = false;

              console.error(err);
            });
        } else {
          this.isDisabled = false;
        }
      });
    },
    /**
     * 关闭对话框时重置表单
     */
    resetDialogForm() {
      this.$refs.dialogForm.resetFields();
    },
    /**
     * 条目数据详情
     * @param row
     */
    detailItem(row) {
      this.detailVisible = true;
      Object.assign(this.detailParams, row);
    },
    /**
     * 修改条目数据
     * @param row
     */
    editItem(row) {
      this.dialogTitle = "编辑限购模板";
      Object.assign(this.itemParams, row);
      this.dialogVisible = true;
      this.method = "PUT";
    },
    /**
     * 删除条目数据
     * @param id
     */
    deleteItem(id) {
      this.$http({
        url: global.apiUrl + "/good/supplyrule?id=" + id,
        method: "DELETE",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.itemParams.supplyId = parseInt(vm.$route.params.supplyId);
    });
  },
};
</script>

<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
